import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { loadAnalytics } from "../analytics";
import { EASE } from "./Reveal";

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("ga_consent");
    if (consent === "granted") {
      loadAnalytics();
    } else if (!consent) {
      const t = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (granted) => {
    localStorage.setItem("ga_consent", granted ? "granted" : "declined");
    setShow(false);
    window.dispatchEvent(new Event("ga-consent-decided"));
    if (granted) loadAnalytics();
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          transition={{ duration: 0.6, ease: EASE }}
          className="fixed inset-x-4 bottom-4 z-[90] mx-auto max-w-xl border border-hairline bg-sand/95 p-6 shadow-[0_20px_60px_rgba(44,42,38,0.2)] backdrop-blur-md lg:bottom-6"
          data-testid="cookie-consent"
        >
          <p className="font-serif text-xl font-light">Бисквитки – само за статистика</p>
          <p className="mt-3 text-sm leading-relaxed text-graphite/65">
            Използвам Google Analytics единствено за анонимна статистика (посещения и кликове), за да подобрявам сайта.
            Без реклами и без проследяване на личността ви.{" "}
            <Link to="/poveritelnost" className="text-burgundy underline underline-offset-4">
              Поверителност
            </Link>
          </p>
          <div className="mt-5 flex gap-3">
            <button
              onClick={() => decide(true)}
              data-testid="cookie-accept-button"
              className="border border-burgundy bg-transparent px-6 py-2.5 text-[11px] uppercase tracking-[0.18em] text-burgundy transition-colors duration-[400ms] hover:bg-burgundy hover:text-sand"
            >
              Приемам
            </button>
            <button
              onClick={() => decide(false)}
              data-testid="cookie-decline-button"
              className="border border-graphite/25 bg-transparent px-6 py-2.5 text-[11px] uppercase tracking-[0.18em] text-graphite/60 transition-colors duration-[400ms] hover:border-graphite hover:text-graphite"
            >
              Отказвам
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
